<template>
  <div>
    <div class="table-file" v-if="allFiles.length > 0">
      <div v-for="(file, index) in allFiles" :key="index" class="input-file align-center">
        <span class="file-name" :class="{isUploaded:isUploaded(file)}">
          <a
            target="_blank"
            :href="download_url ? file['url'] : null"
            rel="noreferrer"
            :download="!download_url ? file['file'] : null"
            @click.self="download($event, file)"
          >

            <div>

              <div 
                class="fileName" 
                :class="nameClass(file)" 
                :title="fileName(file)"
              >
                {{fileName(file)}}
              </div>

              <div class="fileIcons"> 
                <!-- <span v-if="showLoader">
                  <span v-if="file.percent" class="mr10 text-orange">{{file.percent}} %</span>    
                </span> -->
                <span v-if="loading && !file.filename" class="rml50">
                  <i class="fas fa-spinner rotate" ></i>
                </span>
                <span v-if="!loading"> 
                  <span class="uploadSuccess" v-if="isUploaded(file)" @click.prevent="removeFromNew(file)">
                    <i class="fas fa-check-circle"></i>
                  </span>
                  <span class="remove-file" @click.prevent="openDeleteSidePanel(file)">
                    <i class="fas fa-times"></i>
                  </span>
                </span>
              </div>
            </div>
          </a>
        </span>
      </div>
    </div>
    

    <div v-if="gettingFiles" ref="loading" class="text-center">
      <loader-inline></loader-inline>
    </div>

    <div ref="container" id="container" class="file-actions-wrapper">
      <slot name="left"></slot>

      <span id="pickfiles" class="btn" :class="[selectBtnState, {disabled: loading}]" @click="browse">
        {{$tc('uploader.select_files', 1)}}
      </span>
      <span v-if="!programmatic_upload" class="btn" :class="uploadBtnState" @click="upload">
        <i class="fas fa-upload" /> {{$t('uploader.upload')}}
      </span>
      <slot name="buttonRight"></slot>
    </div>

    <div v-if="showLimit" class="text-teal text-center text-sm mt10">
      <i class="fas fa-info-circle"></i>
      <span class="ml5 text-italic">{{$t('uploader.upload_limit', [max_number_files])}}</span>
    </div>

    <pre v-if="!browser_support">{{$t('uploader.browser_support')}}</pre>

    <div class="error mt20">
      <span v-if="error.code">Error #{{error.code}}: </span>
      <span v-if="error.message">{{error.message}}</span>
    </div>

    <side-panel v-if="showDeleteSidePainel" :onClose="closeDeleteSidePanel">
      <template>
          <confirm-delete
            :label="fileName(this.fileToDelete)"
            :onDelete="() => removeFiles(this.fileToDelete)"
            :onCancel="closeDeleteSidePanel"
          />
      </template>
    </side-panel>

  </div>
</template>

<script>
import plupload from "plupload";
import { mapState } from 'vuex';
import { API_HOST } from "../../config/app-const";
import { v4 as uuid } from "uuid";
import {download_file} from "../../helpers/download_file";
import LoaderInline from "../loader-inline";
import apiCall from "../../mixins/api/apiCall";
import SidePanel from '../side-panel';
import ConfirmDelete from "../../components/confirm-delete";

export default {
  name: "input-file",
  components: {
    LoaderInline,
    SidePanel,
    ConfirmDelete,
  },
  props: {
    get_files_url: String,
    remove_url: String,
    upload_url: String,
    download_url: String,
    max_number_files: {
      type: Number,
      default: () => 10
    },
    programmatic_upload: Boolean,
    uploadTrigger: Boolean,
    disableGetFiles: {
      type: Boolean,
      default: false
    },
    max_file_size: {
      type: String,
      default: "10mb"
    },
    prevent_duplicates: {
      type: Boolean,
      default: true
    },
    showLimit: {
      type: Boolean,
      default: false
    },
    multiSelection: {
      type: Boolean,
      default: true
    },
    appendUploadUrlWithUuid: {
      type: Boolean,
      default: true
    },
    prependFileName: String,
  },
  mixins: [apiCall],
  created() {
    this.setUuid()
    if(!this.disableGetFiles) this.getFiles(this.get_files_url)
  },
  mounted() {
    this.$nextTick(() => {
      this.mountUploader()
    })
  },
  data: function() {
    return {
      initiated: false,
      browser_support: false,
      uploaded_files: [],
      new_uploaded_files: [],
      loading: false,
      gettingFiles: false,
      uploader: null,
      uuid: null,
      showDeleteSidePainel: false,
      fileToDelete: null,
      error: {}
    }
  },
  computed: {
    ...mapState({
      access: state => state.user.user.data.accessToken
    }),
    basicUrl() { return this.upload_url ? `${API_HOST}/${this.upload_url}` : null },
    uuidAppendedUrl() { return this.basicUrl ? `${this.basicUrl}/?uuid=${this.uuid}` : null },
    url() { return this.appendUploadUrlWithUuid ? this.uuidAppendedUrl : this.basicUrl },
    addedFiles() { return this.uploader ? this.uploader.files : []},
    allFiles() { return [ ...this.uploaded_files, ...this.addedFiles] },
    current_file_number() { return this.allFiles.length },
    maxReached() { return this.current_file_number >= this.max_number_files},
    maxIsMore() { return this.current_file_number > this.max_number_files},
    selectBtnState() { return this.maxReached ? 'disabled' : ''},
    uploadBtnState() { return this.maxIsMore || this.addedFiles.length === 0 ? 'disabled' : ''},
  },
  methods: {
    setUuid() {
      this.uuid = uuid()
      if(this.uploader) this.uploader.settings.url = this.url
    },
    isAddedFile(file) { return !file.url },
    fileName(file) { return file.file ? file.file : file.name },
    nameClass(file) {  return file.file ? '' : 'disabled' },

    download(e, file){
      if(this.isAddedFile(file)) {
        return e.preventDefault()
      }
      if(this.download_url) {
        e.preventDefault()
        download_file(this.download_url, file, this.access);
      }
    },

    browse() {
      this.clearTemporaryErrors()
    },

    upload() {
      this.loading = true
      this.uploader.start()
    },

    getFiles(url) {
      this.gettingFiles = true
      this.apiCall(url)
        .then((response) =>  this.refreshUploadedFiles(response.data))
        .catch((e) => this.$notify({
          group: 'store_notifications',
          type: 'error',
          text: this.$i18n.t('messages.request.error')
        }))
        .finally(() => {
          this.initiated = true
          this.gettingFiles = false
        })
    },

    openDeleteSidePanel(file) {
      this.fileToDelete = file;
      this.showDeleteSidePainel = true;
    },
    closeDeleteSidePanel: function() {
      this.fileToDelete = null;
      this.showDeleteSidePainel = false;
    },

    removeFiles(file) {
      this.loading = true;

      if(this.isAddedFile(file)) { // just remove selected file
        this.uploader.removeFile(file);
        this.loading = false;
        this.clearTemporaryErrors();
      } else {
        if (!this.remove_url) return console.warn('If you want to delete file, you have to provide "remove_url"')

        this.apiCall(this.remove_url, 'delete', {data: file})
          .then((response) => this.refreshUploadedFiles(response.data))
          .catch((e) => this.$notify({
            group: 'store_notifications',
            type: 'error',
            text: this.$i18n.t('messages.request.error')
          }))
          .finally(() => this.loading = false)
      }

      this.$nextTick(() => {
        this.closeDeleteSidePanel()
      })
    },

    clearTemporaryErrors() {
      if(this.error.code) this.error = {}
    },

    refreshUploadedFiles(data) {
      this.error= {}
      this.uploaded_files = []
      this.uploader.splice(0, this.addedFiles.length)
      if(data.length) data.forEach(file => {
        this.uploaded_files.push(file)
      })
    },

    replaceUuidInFileName(name) {
      if(name.includes('{uuid}')) {
        name = name.replace('{uuid}', this.uuid)
      }
      return name
    },

    setUpUrlSettings(uploader) {
      uploader.settings.url = this.url
    },

    removeFromNew(file) {
      this.new_uploaded_files = this.new_uploaded_files.filter(newFile => newFile.name !== file.file)
    },

    isUploaded(file) {
      return this.new_uploaded_files.find(newFile => newFile.name === file.file)
    },

    mountUploader() {
      let { container } = this.$refs;
      this.uploader = new plupload.Uploader({
        headers: { Authorization: `Token token=${this.access}` },
        runtimes: "html5,flash,silverlight,html4",
        browse_button: "pickfiles",
        container,
        url: this.url,
        multi_selection: this.multiSelection,
        chunk_size: '100mb',
        max_retries: 3,
        dragdrop : true,
        flash_swf_url: "plupload/js/Moxie.swf",
        silverlight_xap_url: "plupload/js/Moxie.xap",
        filters: {
          max_file_size: this.max_file_size,
          prevent_duplicates: this.prevent_duplicates
        },
        settings: {
          url: this.url
        },

        init: {
          PostInit: () => {
            this.browser_support = true
          },

          UploadProgress: (up, file) => {},

          ChunkUploaded: (up, file) => {},

          FileFiltered: (up, file) => {},

          BeforeUpload: (up, file) => {
            up.url = this.url
            if(this.prependFileName) {
              file.name = this.prependFileName + file.name
              file.name = this.replaceUuidInFileName(file.name)
              this.setUpUrlSettings(up)
            }
          },

          UploadFile: (up, file) => {
            this.new_uploaded_files.push(file)
          },

          UploadComplete: (up, files) => {
            this.setUuid()
            if(!this.disableGetFiles) this.getFiles(this.get_files_url);
            this.loading = false
            this.$emit('uploadComplete')
          },

          Error: (up, err) => {
            this.error = err
          }
        }
      });

      this.uploader.init();
    }
  },

  watch: {
    maxReached(state) {
      if(state) {
        return this.uploader.disableBrowse(true)
      }
      else {
        this.uploader.disableBrowse(false)
      }
    },
    maxIsMore(state) {
      if(state) {
        this.error.message = `You cannot add any more files. You have reached the limit of ${this.max_number_files}. Please remove files to be able to Upload.`
        return this.uploader.disableBrowse(true)
      }
      else {
        this.error = {}
        if(!this.maxReached) this.uploader.disableBrowse(false)
      }
    },
    uploadTrigger(newState) {
      if(newState && this.programmatic_upload) {
        this.upload()
      }
    },
  }
};
</script>

<style lang="scss">
@import "../../styles/components/_input-file.scss";
</style>